document.addEventListener('DOMContentLoaded', function() {
  const troperksButtons = document.querySelectorAll('.troperks-action-button');

  if (troperksButtons.length > 0) {
    const debounce = (func, delay) => {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    };

    const showModal = (title, message, onHideCallback) => {
      const modalContainer = document.createElement('div');
      const options = JSON.stringify({
        "enabled": false,
        "showOnce": true,
        "blockTabNavigation": true
      });

      modalContainer.innerHTML = `
        <modal-box id="troperks-modal" class="modal troperks-modal" data-options='${options}' tabindex="-1" role="dialog" aria-modal="true" style="display: none;">
          <div class="container--small">
            <div class="modal-content">
              <div class="modal-heading">
                <div class="modal-heading__text remove-empty-space">
                  <span class="h4 popup-title">${title}</span>
                </div>
                <div class="modal-heading__actions">
                  <button class="modal-close" data-js-close>
                    ${window.KROWN.settings.symbols.close}
                  </button>
                </div>
              </div>
              <div class="rte">${message}</div>
            </div>
          </div>
          <span class="modal-background" data-js-close></span>
        </modal-box>
      `;
      
      const modal = modalContainer.querySelector('modal-box');
      document.body.appendChild(modal);

      setTimeout(() => {
        if (typeof modal.show === 'function') {
          modal.show();
        }
        modal.querySelectorAll('[data-js-close]').forEach(btn => {
          btn.addEventListener('click', () => {
            if (typeof modal.hide === 'function') {
              modal.hide();
            }
            if (onHideCallback) {
              onHideCallback();
            }
            setTimeout(() => modal.remove(), 500);
          });
        });
      }, 50);
    };

    const handleButtonClick = function() {
      const button = this;
      const customerId = button.dataset.customerId;

      // 1. User is not logged in
      if (!customerId) {
        const loggedOutMessage = button.dataset.loggedOutMessage || '<p>Please log in to reveal your discount.</p>';
        const loggedOutTitle = button.dataset.loggedOutModalTitle || 'Login Required';
        showModal(loggedOutTitle, loggedOutMessage);
        return;
      }
      
      button.classList.add('working');
      button.disabled = true;

      let endpoint = button.dataset.endpoint;

      if (customerId) {
        endpoint = `${endpoint}?logged_in_customer_id=${customerId}`;
      }

      fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
           return response.json().catch(() => {
             throw new Error('Network response was not ok');
           }).then(err => { throw err; });
        }
        return response.json();
      })
      .then(data => {
        button.classList.remove('working');

        // 3. User is logged in and has an active subscription
        if (data.has_active_subscription) {
          const discountCode = button.dataset.discountCode;
          let successMessage = button.dataset.successMessage || `<p>Your discount code is: ${discountCode}</p>`;
          successMessage = successMessage.replace(/{{ discount_code }}/g, discountCode);
          const successTitle = button.dataset.successModalTitle || 'Success';
          
          showModal(successTitle, successMessage, () => {
            const finalMessageContainer = button.parentElement.querySelector('.troperks-final-message');
            if (finalMessageContainer) {
              finalMessageContainer.innerHTML = `<div class="troperks-revealed-code"><h4>Your Discount Code:</h4><p>${discountCode}</p></div>`;
              finalMessageContainer.style.display = 'block';
              button.remove();
            }
          });
        } else {
        // 2. User is logged in but has no active subscription
          const noSubscriptionContent = button.parentElement.querySelector('.troperks-subscription-modal-content');
          if (noSubscriptionContent && noSubscriptionContent.innerHTML.trim() !== '') {
            const noSubscriptionTitle = button.dataset.noSubscriptionModalTitle || 'Subscription Required';
            showModal(noSubscriptionTitle, noSubscriptionContent.innerHTML, () => {
              button.disabled = false;
            });
          } else {
            const noSubscriptionMessage = button.dataset.noSubscriptionMessage || '<p>You need an active subscription to see this discount.</p>';
            const noSubscriptionTitle = button.dataset.noSubscriptionModalTitle || 'Subscription Required';
            showModal(noSubscriptionTitle, noSubscriptionMessage, () => {
              button.disabled = false;
            });
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('working');
        const errorTitle = button.dataset.errorModalTitle || 'Error';
        const errorMessage = '<p>An error occurred. Please try again later.</p>';
        showModal(errorTitle, errorMessage, () => {
            button.disabled = false;
        });
      });
    };
    
    troperksButtons.forEach(button => {
      button.addEventListener('click', debounce(handleButtonClick, 500));
    });
  }
}); 